"use strict";

jQuery(document).ready(function ($) {
  $(window).on('scroll', function () {
    var header = $('.header');
    if ($(window).scrollTop() >= 44) header.addClass('header--fixed');else header.removeClass('header--fixed');
  });
  var mainSlider = $('.main-slider__slides');
  mainSlider.slick({
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000
  });
  Fancybox.bind("[data-fancybox]", {});
});